import { render, staticRenderFns } from "./NixiaConversationSidebar.vue?vue&type=template&id=34598bb1&scoped=true&"
import script from "./NixiaConversationSidebar.vue?vue&type=script&lang=js&"
export * from "./NixiaConversationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NixiaConversationSidebar.vue?vue&type=style&index=0&id=34598bb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34598bb1",
  null
  
)

export default component.exports